module.exports = __webpack_public_path__ + "login/static/img/eInsights.39ac08a1.png";